export interface DoctorProfileDataResponse {
    profile: DoctorProfileData;
}

export enum TelegramUserStatus {
    Active = 'active',
    Blocked = 'bot_blocked',
    NotRegistered = 'null',
}

export interface DoctorProfileData {
    id: string;
    role: string;
    status: string;
    firstName: string;
    lastName: string;
    registrationUrl?: string;
    telegramUserStatus?: TelegramUserStatus;
}
